import { Link } from "@wrstudios/components";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { emailFrequencies, getFrequencyName } from "../../stream/invite/utils";
import {
  ButtonLayout,
  LargeText,
  RouteContainer,
  Subscriptions as Subscription,
  Title
} from "./styled/subscriptions-route";

class SubscriptionFrequencyChangeRoute extends Component {
  render() {
    const { hasFetched, frequency, streamName, streamId } = this.props;
    const frequencyLabel =
      frequency === emailFrequencies.NEVER
        ? "No Updates"
        : `${getFrequencyName(frequency)} Updates`;
    return hasFetched ? (
      <RouteContainer>
        <Title>Subscriptions</Title>
        <Subscription>
          <LargeText>
            You've successfully changed your alerts to:
            <br />
            <strong>{frequencyLabel}</strong> on <strong>{streamName}</strong>
          </LargeText>
          <ButtonLayout>
            <Link to={`/streams/${streamId}`}>
              <button className="helix-btn helix-btn--primary helix--btn--large">
                View Stream
              </button>
            </Link>
          </ButtonLayout>
        </Subscription>
      </RouteContainer>
    ) : null;
  }

  componentDidMount() {
    this.props.getStreamSubscription(this.props.subscriptionId);
  }
}
SubscriptionFrequencyChangeRoute.propTypes = {
  frequency: PropTypes.oneOf(Object.values(emailFrequencies)),
  streamName: PropTypes.string,
  streamId: PropTypes.string,
  subscriptionId: PropTypes.string.isRequired,
  getStreamSubscription: PropTypes.func.isRequired
};

export default SubscriptionFrequencyChangeRoute;
